// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__XPEOO","nav":"Main_nav__tJ1tD","footer":"Main_footer__eObrD","content":"Main_content__OsBaf"};